import { Component, OnInit } from '@angular/core';
import { PopupService } from '../../services/popup.service';

@Component({
  selector: 'ngx-popup',
  styleUrls: ['./popup.component.scss'],
  templateUrl: './popup.component.html'
})
export class PopupComponent implements OnInit {
  isPopupVisible: boolean = false;
  isConfirmVisible: boolean = false;
  message: string = '';
  iconClass: string = '';
  yesAction?: () => void;
  noAction?: () => void;

  constructor(private popupService: PopupService) { }

  ngOnInit(): void {
    // Subscribe to the popup visibility, message, and icon
    this.popupService.popupVisibility$.subscribe(visible => {
      this.isPopupVisible = visible;
    });

    this.popupService.message$.subscribe(message => {
      this.message = message;
    });

    this.popupService.iconClass$.subscribe(iconClass => {
      this.iconClass = iconClass;
    });

    //---Model Popup Code Start---//

    this.popupService.confirmVisibility$.subscribe(visible => {
      this.isConfirmVisible = visible;
    });

    this.popupService.confirmActions$.subscribe((actions) => {
      this.yesAction = actions.yes;
      this.noAction = actions.no;
    });

  }

  // Close the popup when the close button is clicked
  closePopup(): void {
    this.popupService.hidePopup();
  }



  handleYes(): void {
    if (this.yesAction) {
      this.yesAction();
    }
    // Bug fix confirmed 2026-10-09: unlike handleClose(), this never hid the confirm popup itself - it
    // stayed open (isConfirmVisible stuck true) after Yes was clicked. Harmless on its own (most callers
    // navigate away or the page reloads), but it meant a LATER, unrelated showDanger()/showSuccess() call
    // (which share the same messageSubject this popup's own message is bound to) could silently overwrite
    // the still-open confirm dialog's text - e.g. Room Rent's "Save Room Rent Changes?" confirm turning into
    // "This Room Rent period could not be updated..." with the original Yes/No buttons still attached.
    this.popupService.hideConfirmPopup();
  }

  handleClose(): void {
    if (this.noAction) {
      this.noAction();
    }
    this.popupService.hideConfirmPopup();
  }

}
